export const API_URL = process.env.REACT_APP_API_URL;
export const MODE = process.env.REACT_APP_MODE;
export const CURRENT_USER_ROLE_KEY = 'CURRENT_USER_ROLE';
